import { League } from '../models';
import { LeagueRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class UpdateLeagueUseCase {
  constructor(
    private leagueRepository: LeagueRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(id: string, updates: Partial<League>, userId?: string): Promise<League> {
    // Moderate text fields before writing
    if (userId) {
      if (updates.name) {
        await this.moderateContent.execute(updates.name, 'league_name', userId);
      }
      if (updates.description) {
        await this.moderateContent.execute(updates.description, 'league_description', userId);
      }
    }

    const updated = await this.leagueRepository.update(id, updates);

    // If league was made public, cascade visibility to all linked tournaments
    if (updates.isPublic === true) {
      await this.leagueRepository.markTournamentsPublic(id);
    }

    return updated;
  }
}
